module.exports = __webpack_public_path__ + "media/images/trees-f8ca8a11020dc360a65715419c07a06c.jpg";